import { render } from "./ProgramPensums.vue?vue&type=template&id=830eb8bc&scoped=true"
import script from "./ProgramPensums.vue?vue&type=script&lang=js"
export * from "./ProgramPensums.vue?vue&type=script&lang=js"

import "./ProgramPensums.vue?vue&type=style&index=0&id=830eb8bc&scoped=true&lang=css"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830eb8bc"]])

export default __exports__